let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fBRlP")).then(() => parcelRequire('dasM8'));